import { render, staticRenderFns } from "./label.vue?vue&type=template&id=283f5eaf&scoped=true"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"
import style0 from "./label.vue?vue&type=style&index=0&id=283f5eaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f5eaf",
  null
  
)

export default component.exports